// Intentionally not importing SearchedListItem to keep Pendo-specific type stable

type SearchResultClickedMetadata = {
  id: string;
  // Pendo expects legacy union (company|project|team)
  type: 'company' | 'project' | 'team';
  isRecent: boolean;
};

export const trackSearchResultClicked = (
  metadata: SearchResultClickedMetadata,
) => {
  window.pendo?.track('SearchResultClicked', metadata);
};
